
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import Resources from './_resources.mdx';
import image1 from "../img/tradly/Low-code-platform-Tradly-1024x268.png"
import image2 from "../img/tradly/Developers-lowcode-marketplace-api-1024x314.png"
import TemplatesCards from '@/Shared/TemplatesCard';
import Cta from '@/partials/Cta'
const Layout = require('@/layouts/RootFileLayout').RootFileLayout;
const meta = {
  "title": "Why Tradly is offering White-label Marketplace Software?",
  "date": "2019-07-10"
};
const slug = 'white-label-marketplace-software';
const tableOfContents = [{
  "title": "How does it work?",
  "slug": "how-does-it-work",
  "children": []
}, {
  "title": "Here is a flow of what you will need to get your app ready to launch. ",
  "slug": "here-is-a-flow-of-what-you-will-need-to-get-your-app-ready-to-launch",
  "children": []
}, {
  "title": "Tradly Platform.",
  "slug": "tradly-platform",
  "children": []
}, {
  "title": "Video Explanation on how to build your marketplace",
  "slug": "video-explanation-on-how-to-build-your-marketplace",
  "children": []
}, {
  "title": "Here’s why Tradly API can help you/your clients",
  "slug": "here-s-why-tradly-api-can-help-you-your-clients",
  "children": []
}, {
  "title": "Resources to build, launch and grow marketplaces",
  "slug": "resources-to-build-launch-and-grow-marketplaces",
  "children": []
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = require('@/layouts/CustomContentsLayout').CustomContentsLayout
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <p>{`Tradly want to bring change in the supply chain of the product/service transaction. `}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Offer accessibility to every business, whether they are small or big. `}</li>
      <li parentName="ul">{`Allow transparency for the buyers with hope and confidence. `}</li>
      <li parentName="ul">{`Making both parties satisfied with their business transaction. `}</li>
      <li parentName="ul">{`Thus creating a safe and friendly community to help each other.`}</li>
    </ul>
    <div class="aspect-w-16 aspect-h-9">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/N8lVEvAB6kI" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
    <_Heading level={2} id={"how-does-it-work"} nextElement={{
      "type": "list",
      "ordered": true,
      "start": 1,
      "spread": false
    }}>How does it work?</_Heading>
    <ol {...{
      "role": "list"
    }}>
      <li parentName="ol"><a parentName="li" {...{
          "href": "https://tradly.app/signup"
        }}>{`Signup for a free account`}</a></li>
      <li parentName="ol">{`Select the `}<a parentName="li" {...{
          "href": "https://tradly.app/templates"
        }}>{`pre-built templates`}</a></li>
      <li parentName="ol">{`Customise the styling using `}<a parentName="li" {...{
          "href": "https://tradly.app/editor"
        }}>{`Editor`}</a></li>
      <li parentName="ol">{`Customise your catalogue, user onboarding, Add Payment, Shipment, Service, etc in the `}<a parentName="li" {...{
          "href": "https://superadmin.tradly.app/"
        }}>{`SuperAdmin`}</a></li>
      <li parentName="ol">{`Web Templates are deployed and you can add your custom domain`}</li>
      <li parentName="ol">{`Optional: Mobile Apps pre-built already ready to be launched.`}</li>
    </ol>
    <TemplatesCards category_id={3865} title={' Marketplace Templates'} isShowBtn={true} mdxType="TemplatesCards" /> 
    <_Heading level={2} id={"here-is-a-flow-of-what-you-will-need-to-get-your-app-ready-to-launch"} nextElement={{
      "type": "paragraph"
    }}>Here is a flow of what you will need to get your app ready to launch. </_Heading>
    <p><strong parentName="p">{`For Business users who prefer no code with small changes in design`}</strong></p>
 <img src={image1} alt="" />
    <p><strong parentName="p">{`For developers (and their companies) who want a unique design and drastic customization`}</strong></p>
 <img src={image2} alt="" />
    <_Heading level={2} id={"tradly-platform"} nextElement={{
      "type": "paragraph"
    }}>Tradly Platform.</_Heading>
    <p><a parentName="p" {...{
        "href": "https://tradly.app"
      }}>{`TradlyPlatform`}</a>{` - Infrastructure as a service.  Tradly have developed a unique set of features that combine social + commerce And have received hundreds of businesses interested in our solutions.`}</p>
    <p>{`The infrastructure is built from scratch to accommodate easy customisation through our superadmin panel + the scale of their business, with thoroughly picked up technologies on the backend.`}</p>
    <_Heading level={2} id={"video-explanation-on-how-to-build-your-marketplace"} nextElement={{
      "type": "jsx"
    }}>Video Explanation on how to build your marketplace</_Heading>
    <img class="w-92 h-82 object-cover rounded-lg shadow-lg" src={require('../img/tradly/image-15-1024x416.png').default} alt="3. Select the revenue model of your multi-vendor marketplace" width="700" />
    <div class="aspect-w-16 aspect-h-9">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/T1sN1C9qUSI" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
    <_Heading level={2} id={"here-s-why-tradly-api-can-help-you-your-clients"} nextElement={{
      "type": "paragraph"
    }}>Here’s why Tradly API can help you/your clients</_Heading>
    <p>{`✔ You won’t need to manage servers/db, write business/commerce logics. It’s pre-built.`}</p>
    <p>{`✔ Not just fundamental features but also advanced commerce features are available in the SuperAdmin`}</p>
    <p>{`✔ Tradly do provide starter Kits for ReactJs, React Native, Flutter, etc`}</p>
    <p>{`✔ You’ll save time by not developing the front end from scratch and still can customise.`}</p>
    <p>{`✔ Your platform is future-proof with API first, and scalable solution.`}<br parentName="p"></br>{`
`}{`✔ You’ll get new product features releases every quarter. `}</p>
    <Cta mdxType="Cta" />
    <_Heading level={2} id={"resources-to-build-launch-and-grow-marketplaces"} nextElement={{
      "type": "jsx"
    }}>Resources to build, launch and grow marketplaces</_Heading>
    <Resources mdxType="Resources" />



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
